"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");

var AccountApi = require("../api/AccountApi");

var AccountActions = require("./AccountActions");
var AccountConstants = require("./AccountConstants");
var AccountFormHelper = require("./AccountFormHelper");
var AccountStore = require("./AccountStore");

class AccountMediaSelector extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedValue: props.initialValue || ""
		};

		this.fetchValue = this.fetchValue.bind(this);
		this.onChange = this.onChange.bind(this);
		this.updateAvailableValues = this.updateAvailableValues.bind(this);
	}

	addHtmlChangeEvent(inputName) {
		var $input = this.findHtmlInput(inputName);

		$input.on("change.mediaSelector", this.fetchValue);
	}

	findHtmlInput(inputName, inputType) {
		inputType = inputType || "input";
		var formParentId = this.getParentFormId();
		var $input = $(`#${formParentId} ${inputType}[name="${inputName}"]`).first();
		return $input;
	}

	removeHtmlChangeEvent(inputName) {
		var $input = this.findHtmlInput(inputName);

		$input.off("change.mediaSelector");
	}

	handleValueSelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var selectedValue = event.currentTarget.value;
		AccountActions.setSelectedMediaOutlet(selectedValue);
	}

	getDisabledState(formParentId) {
		if (formParentId && AccountActions.getIsFormInputDisabled(formParentId)) {
			return true;
		}

		return false;
	}

	getParentFormId() {
		var parentFormId = AccountFormHelper.getParentFormId(this);

		if (!parentFormId || $(`#${parentFormId}`).attr("data-component") === "accountMediaForm") {
			var $firstParentForm = $("[data-component='createAccountForm'],[data-component='primaryContactInformation']").first();
			if ($firstParentForm.length > 0) {
				parentFormId = $firstParentForm.attr("id");
			}
		}
		return parentFormId;
	}

	setDisabledState() {
		var parentFormId = this.getParentFormId();
		//Making sure that the field is disabled if it is hidden
		var isDisabled = this.getDisabledState(parentFormId);
		if (isDisabled !== this.state.disabled) {
			this.setState({ disabled: isDisabled }, () => {
				// If the select is disabled, then we need to remove the invalid class, if it exists,
				// so we do not frustrate the constituent by showing them a required field
				// which they cannot set a value for.
				if (this.state.disabled) {
					$(ReactDOM.findDOMNode(this)).find("select.invalid").removeClass("invalid");
				}
			});
		}
	}

	fetchValue() {
		if (!this._isMounted) {
			return;
		}

		var parentFormId = this.getParentFormId();
		var useAccountDefaultFilterValues = false;

		if (!parentFormId) {
			useAccountDefaultFilterValues = true;
		}

		var requestData = useAccountDefaultFilterValues ? {
			city: this.props.defaultCityFilter,
			country: this.props.defaultCountryFilter || AccountActions.getDefaultCountry(),
			currentMedia: this.state.selectedValue,
			postalCode: this.props.defaultPostalCodeFilter,
			state: this.props.defaultStateFilter
		} : {
			city: this.findHtmlInput("address.city").val(),
			country: AccountActions.getSelectedCountry(parentFormId),
			currentMedia: this.state.selectedValue,
			postalCode: this.findHtmlInput("address.postalCode").val(),
			state: this.findHtmlInput("address.state", "select").val() || this.findHtmlInput("address.state").val()
		};

		var currentRequestString = JSON.stringify(requestData);
		if (AccountActions.getPreviousMediaRequest() === currentRequestString) {
			return;
		}

		AccountActions.setPreviousMediaRequest(currentRequestString);

		AccountApi.getMediaValuesByAddress(requestData).done((data) => {
			//It is mounted and the same/newest request
			if (this._isMounted && AccountActions.getPreviousMediaRequest() === currentRequestString) {
				AccountActions.setAvailableMediaValues(data.items);
			}
		});
	}

	updateAvailableValues() {
		this.setState({ availableValues: AccountActions.getAvailableMediaValues()}, () => {
			// If there are not avialable values then we need to remove the invalid class
			// so we do not frustrate the constituent by showing them a required field
			// which they cannot set a value for.
			if (!this.state.availableValues || !this.state.availableValues.length) {
				$(ReactDOM.findDOMNode(this)).find("select.invalid").removeClass("invalid");
			}
		});
	}

	onChange() {
		if (this._isMounted) {
			this.setState({
				selectedValue: AccountActions.getSelectedMediaOutlet() || ""
			});
		}
	}

	componentDidMount() {
		this._isMounted = true;

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this.props.thisArg || this);
		}

		AccountActions.setSelectedMediaOutlet(this.state.selectedValue);
		this.onChange();

		//Making sure that the field is disabled if it is hidden
		this.setDisabledState();

		//Makes sure we don't make multiple calls to fetch media outlets while Country/PostalCode/State/City are loading default values.
		document.addEventListener("DOMContentLoaded", () => {
			this.addMediaSelectorListeners();
		});
	}

	addMediaSelectorListeners() {
		AccountStore.addSpecificListener(AccountConstants.SET_SELECTED_COUNTRY, this.fetchValue);
		AccountStore.addSpecificListener(AccountConstants.SET_SELECTED_STATE, this.fetchValue);
		AccountStore.addSpecificListener(AccountConstants.SET_MEDIA_OUTLET, this.onChange);
		AccountStore.addSpecificListener(AccountConstants.SET_AVAILABLE_MEDIA_VALUES, this.updateAvailableValues);
		this.addHtmlChangeEvent("address.postalCode");
		this.addHtmlChangeEvent("address.city");

		this.fetchValue();
	}

	componentDidUpdate(nextProps, nextState) {
		//Making sure that the field is disabled if it is hidden
		this.setDisabledState();
	}

	componentWillUnmount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this.props.thisArg || this);
		}
		AccountStore.removeSpecificListener(AccountConstants.SET_SELECTED_COUNTRY, this.fetchValue);
		AccountStore.removeSpecificListener(AccountConstants.SET_SELECTED_STATE, this.fetchValue);
		AccountStore.removeSpecificListener(AccountConstants.SET_MEDIA_OUTLET, this.onChange);
		AccountStore.removeSpecificListener(AccountConstants.SET_AVAILABLE_MEDIA_VALUES, this.updateAvailableValues);
		this.removeHtmlChangeEvent("address.postalCode");
		this.removeHtmlChangeEvent("address.city");

		this._isMounted = false;
	}

	render() {
		var availableValues = this.state.availableValues;

		return (
			<div
				data-react-component-name="AccountMediaSelector"
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
				data-react-component-category={this.props.reactComponentCategory}
			>
				<select
					className={classNames("form-control", "account-media-selector")}
					style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
					data-override-classes={this.props.childClass}
					disabled={this.props.disabled || this.state.disabled || (!this.props.isDesignMode && (!availableValues || !availableValues.length))}
					name="mediaOutlet"
					onChange={this.handleValueSelected}
					data-required={this.props.dataRequired}
					required={this.props.required || this.props.dataRequired}
					value={this.state.selectedValue}
				>
					<option value=""></option>
					{availableValues && availableValues.map((availableValue) => {
						return (
							<option className="availableMedia" key={availableValue.id} value={availableValue.id}>
								{availableValue.description}
							</option>
						);
					})}
				</select>
			</div>
		);
	}
}

AccountMediaSelector.propTypes = {
	isDesignMode: PropTypes.bool,
	dataRequired: PropTypes.bool,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,

	reactComponentCategory: PropTypes.string,
	initialValue: PropTypes.string,
	defaultCityFilter: PropTypes.string,
	defaultCountryFilter: PropTypes.string,
	defaultPostalCodeFilter: PropTypes.string,
	defaultStateFilter: PropTypes.string
};

module.exports = AccountMediaSelector;
